import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormModelDirective } from "../../../abstractions/form-model.directive";

@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true
        }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DatePickerComponent extends FormModelDirective {

  readonly label = input<string | null>(null);

  readonly min = input<string>('');

  readonly max = input<string>('');

  onOpenCalendar(input: HTMLInputElement): void {
    input.showPicker();
  }

}
